export default __webpack_public_path__ + "static/media/bracelet_4.a5dce33f.webp";